const teaserData = gql`
  fragment TeaserData on NutritionArticleRecord {
    id
    slug
    title
    excerpt
    image {
      alt
      title
      blurUpThumb
    }
    squareImage: image {
      url(imgixParams: { w: 320, h: 320, fm: jpg, fit: crop, crop: focalpoint })
    }
    rectangularImage: image {
      url(imgixParams: { w: 480, h: 320, fm: jpg, fit: crop, crop: focalpoint })
    }
  }
`

const categoryDataQuery = gql`
  query CategoryData($slug: String!, $locale: SiteLocale) {
    category: nutritionCategory(
      filter: { slug: { eq: $slug } }
      locale: $locale
    ) {
      id
      name
      slug
      description
      _locales
      image {
        responsiveImage(imgixParams: { auto: format, q: 10 }) {
          src
          width
          height
          bgColor
        }
      }
      meta: _seoMetaTags {
        tag
        content
        attributes
      }
    }
  }
`
const allStoriesQuery = gql`
  ${teaserData}
  query AllStoriesCategory($id: ItemId!, $skip: IntType = 0) {
    meta: _allNutritionArticlesMeta(
      filter: { categories: { anyIn: [$id] }, archived: { eq: false } }
    ) {
      count
    }
    recipesMeta: _allNutritionRecipesMeta(
      filter: { categories: { anyIn: [$id] } }
    ) {
      count
    }
    allStories: allNutritionArticles(
      first: 10
      skip: $skip
      filter: { categories: { anyIn: [$id] }, archived: { eq: false } }
      orderBy: _createdAt_DESC
    ) {
      ...TeaserData
    }
    allRecipes: allNutritionRecipes(
      first: 12
      skip: $skip
      filter: { categories: { anyIn: [$id] } }
      orderBy: _createdAt_DESC
    ) {
      id
      recipeName
      slug
      image {
        responsiveImage(
          imgixParams: { w: 480, h: 270, fit: crop, crop: focalpoint }
        ) {
          srcSet
          webpSrcSet
          src
          alt
          title
          base64
          width
          height
        }
      }
      intro
      time
      calories
    }
    featuredStories: allNutritionArticles(
      first: 3
      filter: {
        categories: { anyIn: [$id] }
        featured: { eq: true }
        archived: { eq: false }
      }
      orderBy: _createdAt_DESC
    ) {
      ...TeaserData
    }
  }
`
const recipesDataQuery = gql`
  query AllNutritionRecipes($skip: IntType = 0, $first: IntType = 12) {
    meta: _allNutritionRecipesMeta {
      count
    }
    allRecipes: allNutritionRecipes(
      first: $first
      skip: $skip
      orderBy: _createdAt_DESC
    ) {
      id
      recipeName
      slug
      image {
        responsiveImage(
          imgixParams: { w: 480, h: 270, fm: jpg, fit: crop, crop: focalpoint }
        ) {
          srcSet
          webpSrcSet
          src
          alt
          title
          base64
          width
          height
        }
      }
      intro
      time
      calories
    }
  }
`
export { allStoriesQuery, categoryDataQuery, recipesDataQuery }
